import { FC } from 'react';

import { Button } from '../../common/Button';
import { NavigationWrapper } from '../../common/NavigationWrapper';
import { SUBSCRIPTION_NAME } from '../../../constants';
import { Panel, PanelTitle, PanelText, PanelList, PanelNotice } from '../../common/Panel';
import { Grid } from '../../common/Grid';

export const PreviousMemberInformation: FC<{
  loadingAny: boolean,
  pauseCancel: Function
}> = ({ loadingAny, pauseCancel }) => {

  const handlePauseCancel = () => pauseCancel();

  return (
    <>
      <Panel>
        <PanelTitle>現在お客様の定期便は一時停止状態となっています。</PanelTitle>
        <PanelText>
          <p>
            お客様がご契約されておりました定期便サービス「ポケサブ！」は<b>2024年6月27日(木)をもちまして終了し、2024年6月28日(金)より「{SUBSCRIPTION_NAME}」として生まれ変わりました。</b><br/>
            <strong>月に一度「グミッツェルBOX12個セット」1点と、月替わりのヒトツブカンロの商品1点をお届けするサービスです。</strong><br/>
            事前にご案内いたしました通り、現在契約中のお客様のアカウントを全て一時停止状態にいたしました。<br/>
            「{SUBSCRIPTION_NAME}」の利用をご希望される場合、以下の「再開後の手順」をご確認の上、「再開する」ボタンを押してください。
          </p>
        </PanelText>
        <div style={{ marginTop: 'var(--appGutterEXSmall)'}}/>
        <PanelTitle useH4={true}>再開後の手順</PanelTitle>
        <Grid>
          <PanelList items={[
            'マイページの上部に「次回お届け予定商品」という箇所があります。',
            '契約再開後は「現在お届け予定の商品はありません」となっています。',
            '下部「商品を追加する」ボタンを押していただくと、契約に商品が追加されます。',
            `毎月の${SUBSCRIPTION_NAME}をお楽しみください！`
          ]}/>
          <PanelNotice>
            もし契約再開後「商品を追加する」ボタンを押さなかった場合、システムの都合上、お届けする商品が存在しないにもかかわらず、契約に設定された送料500円が毎月ご請求される形となってしまいます。<br/>
            契約を再開されたお客様は必ず「商品を追加する」ボタンを押していただくか、もしくは契約をご希望でない場合は「一時停止する」または「解約する」を選択いただきますようお願いいたします。
          </PanelNotice>
        </Grid>
      </Panel>
      <NavigationWrapper>
        <Button type={'primary'} onClick={handlePauseCancel} disabled={loadingAny}>
          再開する
        </Button>
        <Button type={'secondary'} internalLink="/cancel">
          解約する
        </Button>
      </NavigationWrapper>
    </>
  );
}
